<!--
 * @Author: LiZhiWei
 * @Date: 2026-08-12 15:10:00
 * @Description: 联系行动区 Contact Action - 标题 + 说明 + 3 项咨询入口，对齐高保真原型
-->
<template>
  <section class="section contact-action" data-od-id="contact-action">
    <div class="page-container">
      <div class="contact-heading">
        <h2>按需求进入对应咨询路径</h2>
        <p>合作与研学需求可直接提交，采购咨询请先选择具体产品，以便保留产品关联。</p>
      </div>
      <div class="contact-band" aria-label="咨询服务入口">
        <contact-dialog default-type="COOPERATION">
          <button class="contact-option" type="button">
            <span>01</span>
            <span>
              <strong>合作咨询</strong>
              <small>科研协同、中试验证、成果转化、定制生产</small>
            </span>
            <span aria-hidden="true">→</span>
          </button>
        </contact-dialog>
        <nuxt-link class="contact-option" to="/mall">
          <span>02</span>
          <span>
            <strong>采购咨询</strong>
            <small>选择具体产品后提交采购数量、使用场景与交付需求</small>
          </span>
          <span aria-hidden="true">→</span>
        </nuxt-link>
        <contact-dialog default-type="EDUCATION">
          <button class="contact-option" type="button">
            <span>03</span>
            <span>
              <strong>研学咨询</strong>
              <small>学校、机构、亲子团队与活动需求</small>
            </span>
            <span aria-hidden="true">→</span>
          </button>
        </contact-dialog>
      </div>
    </div>
  </section>
</template>

<style scoped lang="scss">
  // 组件样式在 inner-page.scss 中统一定义
</style>
